import { __assign, __extends } from "tslib";
import { RekognitionServiceException as __BaseException } from "./RekognitionServiceException";
var AccessDeniedException = (function (_super) {
    __extends(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "AccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return AccessDeniedException;
}(__BaseException));
export { AccessDeniedException };
export var Attribute;
(function (Attribute) {
    Attribute["ALL"] = "ALL";
    Attribute["DEFAULT"] = "DEFAULT";
})(Attribute || (Attribute = {}));
export var BodyPart;
(function (BodyPart) {
    BodyPart["FACE"] = "FACE";
    BodyPart["HEAD"] = "HEAD";
    BodyPart["LEFT_HAND"] = "LEFT_HAND";
    BodyPart["RIGHT_HAND"] = "RIGHT_HAND";
})(BodyPart || (BodyPart = {}));
export var ProtectiveEquipmentType;
(function (ProtectiveEquipmentType) {
    ProtectiveEquipmentType["FACE_COVER"] = "FACE_COVER";
    ProtectiveEquipmentType["HAND_COVER"] = "HAND_COVER";
    ProtectiveEquipmentType["HEAD_COVER"] = "HEAD_COVER";
})(ProtectiveEquipmentType || (ProtectiveEquipmentType = {}));
export var LandmarkType;
(function (LandmarkType) {
    LandmarkType["chinBottom"] = "chinBottom";
    LandmarkType["eyeLeft"] = "eyeLeft";
    LandmarkType["eyeRight"] = "eyeRight";
    LandmarkType["leftEyeBrowLeft"] = "leftEyeBrowLeft";
    LandmarkType["leftEyeBrowRight"] = "leftEyeBrowRight";
    LandmarkType["leftEyeBrowUp"] = "leftEyeBrowUp";
    LandmarkType["leftEyeDown"] = "leftEyeDown";
    LandmarkType["leftEyeLeft"] = "leftEyeLeft";
    LandmarkType["leftEyeRight"] = "leftEyeRight";
    LandmarkType["leftEyeUp"] = "leftEyeUp";
    LandmarkType["leftPupil"] = "leftPupil";
    LandmarkType["midJawlineLeft"] = "midJawlineLeft";
    LandmarkType["midJawlineRight"] = "midJawlineRight";
    LandmarkType["mouthDown"] = "mouthDown";
    LandmarkType["mouthLeft"] = "mouthLeft";
    LandmarkType["mouthRight"] = "mouthRight";
    LandmarkType["mouthUp"] = "mouthUp";
    LandmarkType["nose"] = "nose";
    LandmarkType["noseLeft"] = "noseLeft";
    LandmarkType["noseRight"] = "noseRight";
    LandmarkType["rightEyeBrowLeft"] = "rightEyeBrowLeft";
    LandmarkType["rightEyeBrowRight"] = "rightEyeBrowRight";
    LandmarkType["rightEyeBrowUp"] = "rightEyeBrowUp";
    LandmarkType["rightEyeDown"] = "rightEyeDown";
    LandmarkType["rightEyeLeft"] = "rightEyeLeft";
    LandmarkType["rightEyeRight"] = "rightEyeRight";
    LandmarkType["rightEyeUp"] = "rightEyeUp";
    LandmarkType["rightPupil"] = "rightPupil";
    LandmarkType["upperJawlineLeft"] = "upperJawlineLeft";
    LandmarkType["upperJawlineRight"] = "upperJawlineRight";
})(LandmarkType || (LandmarkType = {}));
export var KnownGenderType;
(function (KnownGenderType) {
    KnownGenderType["Female"] = "Female";
    KnownGenderType["Male"] = "Male";
    KnownGenderType["Nonbinary"] = "Nonbinary";
    KnownGenderType["Unlisted"] = "Unlisted";
})(KnownGenderType || (KnownGenderType = {}));
export var GenderType;
(function (GenderType) {
    GenderType["Female"] = "Female";
    GenderType["Male"] = "Male";
})(GenderType || (GenderType = {}));
export var CelebrityRecognitionSortBy;
(function (CelebrityRecognitionSortBy) {
    CelebrityRecognitionSortBy["ID"] = "ID";
    CelebrityRecognitionSortBy["TIMESTAMP"] = "TIMESTAMP";
})(CelebrityRecognitionSortBy || (CelebrityRecognitionSortBy = {}));
export var QualityFilter;
(function (QualityFilter) {
    QualityFilter["AUTO"] = "AUTO";
    QualityFilter["HIGH"] = "HIGH";
    QualityFilter["LOW"] = "LOW";
    QualityFilter["MEDIUM"] = "MEDIUM";
    QualityFilter["NONE"] = "NONE";
})(QualityFilter || (QualityFilter = {}));
export var OrientationCorrection;
(function (OrientationCorrection) {
    OrientationCorrection["ROTATE_0"] = "ROTATE_0";
    OrientationCorrection["ROTATE_180"] = "ROTATE_180";
    OrientationCorrection["ROTATE_270"] = "ROTATE_270";
    OrientationCorrection["ROTATE_90"] = "ROTATE_90";
})(OrientationCorrection || (OrientationCorrection = {}));
var ImageTooLargeException = (function (_super) {
    __extends(ImageTooLargeException, _super);
    function ImageTooLargeException(opts) {
        var _this = _super.call(this, __assign({ name: "ImageTooLargeException", $fault: "client" }, opts)) || this;
        _this.name = "ImageTooLargeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ImageTooLargeException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ImageTooLargeException;
}(__BaseException));
export { ImageTooLargeException };
var InternalServerError = (function (_super) {
    __extends(InternalServerError, _super);
    function InternalServerError(opts) {
        var _this = _super.call(this, __assign({ name: "InternalServerError", $fault: "server" }, opts)) || this;
        _this.name = "InternalServerError";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalServerError.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InternalServerError;
}(__BaseException));
export { InternalServerError };
var InvalidImageFormatException = (function (_super) {
    __extends(InvalidImageFormatException, _super);
    function InvalidImageFormatException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidImageFormatException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidImageFormatException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidImageFormatException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InvalidImageFormatException;
}(__BaseException));
export { InvalidImageFormatException };
var InvalidParameterException = (function (_super) {
    __extends(InvalidParameterException, _super);
    function InvalidParameterException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InvalidParameterException;
}(__BaseException));
export { InvalidParameterException };
var InvalidS3ObjectException = (function (_super) {
    __extends(InvalidS3ObjectException, _super);
    function InvalidS3ObjectException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidS3ObjectException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidS3ObjectException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidS3ObjectException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InvalidS3ObjectException;
}(__BaseException));
export { InvalidS3ObjectException };
var ProvisionedThroughputExceededException = (function (_super) {
    __extends(ProvisionedThroughputExceededException, _super);
    function ProvisionedThroughputExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "ProvisionedThroughputExceededException", $fault: "client" }, opts)) || this;
        _this.name = "ProvisionedThroughputExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ProvisionedThroughputExceededException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ProvisionedThroughputExceededException;
}(__BaseException));
export { ProvisionedThroughputExceededException };
var ThrottlingException = (function (_super) {
    __extends(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, __assign({ name: "ThrottlingException", $fault: "server" }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ThrottlingException;
}(__BaseException));
export { ThrottlingException };
export var ContentClassifier;
(function (ContentClassifier) {
    ContentClassifier["FREE_OF_ADULT_CONTENT"] = "FreeOfAdultContent";
    ContentClassifier["FREE_OF_PERSONALLY_IDENTIFIABLE_INFORMATION"] = "FreeOfPersonallyIdentifiableInformation";
})(ContentClassifier || (ContentClassifier = {}));
export var ContentModerationSortBy;
(function (ContentModerationSortBy) {
    ContentModerationSortBy["NAME"] = "NAME";
    ContentModerationSortBy["TIMESTAMP"] = "TIMESTAMP";
})(ContentModerationSortBy || (ContentModerationSortBy = {}));
var LimitExceededException = (function (_super) {
    __extends(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return LimitExceededException;
}(__BaseException));
export { LimitExceededException };
var ResourceInUseException = (function (_super) {
    __extends(ResourceInUseException, _super);
    function ResourceInUseException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceInUseException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceInUseException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceInUseException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ResourceInUseException;
}(__BaseException));
export { ResourceInUseException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
var ServiceQuotaExceededException = (function (_super) {
    __extends(ServiceQuotaExceededException, _super);
    function ServiceQuotaExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "ServiceQuotaExceededException", $fault: "client" }, opts)) || this;
        _this.name = "ServiceQuotaExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ServiceQuotaExceededException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ServiceQuotaExceededException;
}(__BaseException));
export { ServiceQuotaExceededException };
var ResourceAlreadyExistsException = (function (_super) {
    __extends(ResourceAlreadyExistsException, _super);
    function ResourceAlreadyExistsException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceAlreadyExistsException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceAlreadyExistsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceAlreadyExistsException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ResourceAlreadyExistsException;
}(__BaseException));
export { ResourceAlreadyExistsException };
export var DatasetType;
(function (DatasetType) {
    DatasetType["TEST"] = "TEST";
    DatasetType["TRAIN"] = "TRAIN";
})(DatasetType || (DatasetType = {}));
export var DatasetStatus;
(function (DatasetStatus) {
    DatasetStatus["CREATE_COMPLETE"] = "CREATE_COMPLETE";
    DatasetStatus["CREATE_FAILED"] = "CREATE_FAILED";
    DatasetStatus["CREATE_IN_PROGRESS"] = "CREATE_IN_PROGRESS";
    DatasetStatus["DELETE_IN_PROGRESS"] = "DELETE_IN_PROGRESS";
    DatasetStatus["UPDATE_COMPLETE"] = "UPDATE_COMPLETE";
    DatasetStatus["UPDATE_FAILED"] = "UPDATE_FAILED";
    DatasetStatus["UPDATE_IN_PROGRESS"] = "UPDATE_IN_PROGRESS";
})(DatasetStatus || (DatasetStatus = {}));
export var DatasetStatusMessageCode;
(function (DatasetStatusMessageCode) {
    DatasetStatusMessageCode["CLIENT_ERROR"] = "CLIENT_ERROR";
    DatasetStatusMessageCode["SERVICE_ERROR"] = "SERVICE_ERROR";
    DatasetStatusMessageCode["SUCCESS"] = "SUCCESS";
})(DatasetStatusMessageCode || (DatasetStatusMessageCode = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["CREATED"] = "CREATED";
    ProjectStatus["CREATING"] = "CREATING";
    ProjectStatus["DELETING"] = "DELETING";
})(ProjectStatus || (ProjectStatus = {}));
var InvalidPolicyRevisionIdException = (function (_super) {
    __extends(InvalidPolicyRevisionIdException, _super);
    function InvalidPolicyRevisionIdException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidPolicyRevisionIdException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidPolicyRevisionIdException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidPolicyRevisionIdException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InvalidPolicyRevisionIdException;
}(__BaseException));
export { InvalidPolicyRevisionIdException };
export var ProjectVersionStatus;
(function (ProjectVersionStatus) {
    ProjectVersionStatus["COPYING_COMPLETED"] = "COPYING_COMPLETED";
    ProjectVersionStatus["COPYING_FAILED"] = "COPYING_FAILED";
    ProjectVersionStatus["COPYING_IN_PROGRESS"] = "COPYING_IN_PROGRESS";
    ProjectVersionStatus["DELETING"] = "DELETING";
    ProjectVersionStatus["FAILED"] = "FAILED";
    ProjectVersionStatus["RUNNING"] = "RUNNING";
    ProjectVersionStatus["STARTING"] = "STARTING";
    ProjectVersionStatus["STOPPED"] = "STOPPED";
    ProjectVersionStatus["STOPPING"] = "STOPPING";
    ProjectVersionStatus["TRAINING_COMPLETED"] = "TRAINING_COMPLETED";
    ProjectVersionStatus["TRAINING_FAILED"] = "TRAINING_FAILED";
    ProjectVersionStatus["TRAINING_IN_PROGRESS"] = "TRAINING_IN_PROGRESS";
})(ProjectVersionStatus || (ProjectVersionStatus = {}));
var InvalidPaginationTokenException = (function (_super) {
    __extends(InvalidPaginationTokenException, _super);
    function InvalidPaginationTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidPaginationTokenException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidPaginationTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidPaginationTokenException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return InvalidPaginationTokenException;
}(__BaseException));
export { InvalidPaginationTokenException };
export var StreamProcessorStatus;
(function (StreamProcessorStatus) {
    StreamProcessorStatus["FAILED"] = "FAILED";
    StreamProcessorStatus["RUNNING"] = "RUNNING";
    StreamProcessorStatus["STARTING"] = "STARTING";
    StreamProcessorStatus["STOPPED"] = "STOPPED";
    StreamProcessorStatus["STOPPING"] = "STOPPING";
    StreamProcessorStatus["UPDATING"] = "UPDATING";
})(StreamProcessorStatus || (StreamProcessorStatus = {}));
var ResourceNotReadyException = (function (_super) {
    __extends(ResourceNotReadyException, _super);
    function ResourceNotReadyException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotReadyException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotReadyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotReadyException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return ResourceNotReadyException;
}(__BaseException));
export { ResourceNotReadyException };
var HumanLoopQuotaExceededException = (function (_super) {
    __extends(HumanLoopQuotaExceededException, _super);
    function HumanLoopQuotaExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "HumanLoopQuotaExceededException", $fault: "client" }, opts)) || this;
        _this.name = "HumanLoopQuotaExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, HumanLoopQuotaExceededException.prototype);
        _this.ResourceType = opts.ResourceType;
        _this.QuotaCode = opts.QuotaCode;
        _this.ServiceCode = opts.ServiceCode;
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return HumanLoopQuotaExceededException;
}(__BaseException));
export { HumanLoopQuotaExceededException };
export var TextTypes;
(function (TextTypes) {
    TextTypes["LINE"] = "LINE";
    TextTypes["WORD"] = "WORD";
})(TextTypes || (TextTypes = {}));
export var FaceAttributes;
(function (FaceAttributes) {
    FaceAttributes["ALL"] = "ALL";
    FaceAttributes["DEFAULT"] = "DEFAULT";
})(FaceAttributes || (FaceAttributes = {}));
export var FaceSearchSortBy;
(function (FaceSearchSortBy) {
    FaceSearchSortBy["INDEX"] = "INDEX";
    FaceSearchSortBy["TIMESTAMP"] = "TIMESTAMP";
})(FaceSearchSortBy || (FaceSearchSortBy = {}));
export var VideoJobStatus;
(function (VideoJobStatus) {
    VideoJobStatus["FAILED"] = "FAILED";
    VideoJobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VideoJobStatus["SUCCEEDED"] = "SUCCEEDED";
})(VideoJobStatus || (VideoJobStatus = {}));
export var VideoColorRange;
(function (VideoColorRange) {
    VideoColorRange["FULL"] = "FULL";
    VideoColorRange["LIMITED"] = "LIMITED";
})(VideoColorRange || (VideoColorRange = {}));
export var LabelDetectionSortBy;
(function (LabelDetectionSortBy) {
    LabelDetectionSortBy["NAME"] = "NAME";
    LabelDetectionSortBy["TIMESTAMP"] = "TIMESTAMP";
})(LabelDetectionSortBy || (LabelDetectionSortBy = {}));
export var PersonTrackingSortBy;
(function (PersonTrackingSortBy) {
    PersonTrackingSortBy["INDEX"] = "INDEX";
    PersonTrackingSortBy["TIMESTAMP"] = "TIMESTAMP";
})(PersonTrackingSortBy || (PersonTrackingSortBy = {}));
export var TechnicalCueType;
(function (TechnicalCueType) {
    TechnicalCueType["BLACK_FRAMES"] = "BlackFrames";
    TechnicalCueType["COLOR_BARS"] = "ColorBars";
    TechnicalCueType["CONTENT"] = "Content";
    TechnicalCueType["END_CREDITS"] = "EndCredits";
    TechnicalCueType["OPENING_CREDITS"] = "OpeningCredits";
    TechnicalCueType["SLATE"] = "Slate";
    TechnicalCueType["STUDIO_LOGO"] = "StudioLogo";
})(TechnicalCueType || (TechnicalCueType = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["SHOT"] = "SHOT";
    SegmentType["TECHNICAL_CUE"] = "TECHNICAL_CUE";
})(SegmentType || (SegmentType = {}));
var IdempotentParameterMismatchException = (function (_super) {
    __extends(IdempotentParameterMismatchException, _super);
    function IdempotentParameterMismatchException(opts) {
        var _this = _super.call(this, __assign({ name: "IdempotentParameterMismatchException", $fault: "client" }, opts)) || this;
        _this.name = "IdempotentParameterMismatchException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IdempotentParameterMismatchException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return IdempotentParameterMismatchException;
}(__BaseException));
export { IdempotentParameterMismatchException };
export var Reason;
(function (Reason) {
    Reason["EXCEEDS_MAX_FACES"] = "EXCEEDS_MAX_FACES";
    Reason["EXTREME_POSE"] = "EXTREME_POSE";
    Reason["LOW_BRIGHTNESS"] = "LOW_BRIGHTNESS";
    Reason["LOW_CONFIDENCE"] = "LOW_CONFIDENCE";
    Reason["LOW_FACE_QUALITY"] = "LOW_FACE_QUALITY";
    Reason["LOW_SHARPNESS"] = "LOW_SHARPNESS";
    Reason["SMALL_BOUNDING_BOX"] = "SMALL_BOUNDING_BOX";
})(Reason || (Reason = {}));
var MalformedPolicyDocumentException = (function (_super) {
    __extends(MalformedPolicyDocumentException, _super);
    function MalformedPolicyDocumentException(opts) {
        var _this = _super.call(this, __assign({ name: "MalformedPolicyDocumentException", $fault: "client" }, opts)) || this;
        _this.name = "MalformedPolicyDocumentException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MalformedPolicyDocumentException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return MalformedPolicyDocumentException;
}(__BaseException));
export { MalformedPolicyDocumentException };
var VideoTooLargeException = (function (_super) {
    __extends(VideoTooLargeException, _super);
    function VideoTooLargeException(opts) {
        var _this = _super.call(this, __assign({ name: "VideoTooLargeException", $fault: "client" }, opts)) || this;
        _this.name = "VideoTooLargeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, VideoTooLargeException.prototype);
        _this.Message = opts.Message;
        _this.Code = opts.Code;
        _this.Logref = opts.Logref;
        return _this;
    }
    return VideoTooLargeException;
}(__BaseException));
export { VideoTooLargeException };
export var StreamProcessorParameterToDelete;
(function (StreamProcessorParameterToDelete) {
    StreamProcessorParameterToDelete["ConnectedHomeMinConfidence"] = "ConnectedHomeMinConfidence";
    StreamProcessorParameterToDelete["RegionsOfInterest"] = "RegionsOfInterest";
})(StreamProcessorParameterToDelete || (StreamProcessorParameterToDelete = {}));
export var AgeRangeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3ObjectFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GroundTruthManifestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AssetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AudioMetadataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BeardFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BlackFrameFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BoundingBoxFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CoversBodyPartFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EquipmentDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProtectiveEquipmentBodyPartFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EmotionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LandmarkFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PoseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImageQualityFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SmileFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ComparedFaceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KnownGenderFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CelebrityFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EyeglassesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EyeOpenFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GenderFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MouthOpenFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MustacheFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SunglassesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceDetailFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CelebrityDetailFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CelebrityRecognitionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ComparedSourceImageFaceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompareFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompareFacesMatchFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompareFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectedHomeSettingsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectedHomeSettingsForUpdateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ModerationLabelFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ContentModerationDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OutputConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CopyProjectVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CopyProjectVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCollectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateCollectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetSourceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDatasetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateDatasetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateProjectRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateProjectResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TestingDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TrainingDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateProjectVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateProjectVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorDataSharingPreferenceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KinesisVideoStreamFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorNotificationChannelFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KinesisDataStreamFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var S3DestinationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegionOfInterestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceSearchSettingsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorSettingsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GeometryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CustomLabelFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetChangesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetStatsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetLabelStatsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetLabelDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatasetMetadataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCollectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCollectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDatasetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDatasetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteProjectVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeCollectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeCollectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeDatasetRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeDatasetResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeProjectsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProjectDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeProjectsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeProjectVersionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SummaryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EvaluationResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ValidationDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TestingDataResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TrainingDataResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProjectVersionDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeProjectVersionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectCustomLabelsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectCustomLabelsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectionFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectLabelsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ParentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LabelFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectLabelsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var HumanLoopDataAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var HumanLoopConfigFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectModerationLabelsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var HumanLoopActivationOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectModerationLabelsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProtectiveEquipmentSummarizationAttributesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectProtectiveEquipmentRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProtectiveEquipmentPersonFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProtectiveEquipmentSummaryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectProtectiveEquipmentResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectTextFiltersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectTextRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TextDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetectTextResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DistributeDatasetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DistributeDatasetEntriesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DistributeDatasetEntriesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceMatchFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FaceRecordFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCelebrityInfoRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCelebrityInfoResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCelebrityRecognitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VideoMetadataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCelebrityRecognitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetContentModerationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetContentModerationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFaceDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFaceDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFaceSearchRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PersonDetailFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PersonMatchFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetFaceSearchResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLabelDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LabelDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetLabelDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPersonTrackingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PersonDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPersonTrackingResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSegmentDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ShotSegmentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TechnicalCueSegmentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SegmentDetectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SegmentTypeInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSegmentDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTextDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TextDetectionResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTextDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IndexFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UnindexedFaceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IndexFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KinesisVideoStreamStartSelectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCollectionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCollectionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDatasetEntriesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDatasetEntriesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDatasetLabelsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDatasetLabelsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListProjectPoliciesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProjectPolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListProjectPoliciesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamProcessorsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamProcessorsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NotificationChannelFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutProjectPolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutProjectPolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecognizeCelebritiesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecognizeCelebritiesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchFacesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchFacesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchFacesByImageRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchFacesByImageResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VideoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCelebrityRecognitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCelebrityRecognitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartContentModerationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartContentModerationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartFaceDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartFaceDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartFaceSearchRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartFaceSearchResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartLabelDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartLabelDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartPersonTrackingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartPersonTrackingResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartProjectVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartProjectVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartShotDetectionFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTechnicalCueDetectionFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartSegmentDetectionFiltersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartSegmentDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartSegmentDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessingStartSelectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessingStopSelectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTextDetectionFiltersFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTextDetectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTextDetectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopProjectVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopProjectVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDatasetEntriesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDatasetEntriesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamProcessorSettingsForUpdateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateStreamProcessorRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateStreamProcessorResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
